import ReactDOM from "react-dom/client";

import { installFetchXLastWriteMiddleware } from "@/lib/x-last-write";

import "./styles/App.css";

installFetchXLastWriteMiddleware();

import App from "./App";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(<App />);
